
import { defineComponent } from 'vue';

import Anchor from '@/elements/anchor/Anchor.vue';
import Box, { BoxColor, BoxColorVariant } from '@/elements/box/Box';
import Copyright from '@/components/copyright/Copyright.vue';

export default defineComponent({
  name: 'Footer',
  components: { Anchor, Box, Copyright },
  props: {
    color: {
      type: String as () => BoxColor,
      default: 'white',
    },
    variant: {
      type: String as () => BoxColorVariant,
      default: 'neutral',
    },
  },
  setup(_, { slots }) {
    return {
      hasTop: slots.top !== undefined,
      hasBottom: slots.bottom !== undefined,
    };
  },
});
